// Mobile Menu Toggle - global, von inline onclick aus aufrufbar
function toggleMobileMenu() {
    var menu = document.querySelector('.nav-menu');
    var toggle = document.querySelector('.mobile-menu-toggle');
    if (!menu) return;
    var isOpen = menu.classList.toggle('active');
    if (toggle) {
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        toggle.classList.toggle('is-open', isOpen);
    }
    document.body.classList.toggle('nav-open', isOpen);
}

// Klick-Ausloeser ohne Inline-Handler (SEO-Audit 2026-10-17, M23).
// Die CSP erlaubt seit Oktober 2026 kein 'unsafe-inline' mehr fuer Skripte,
// onclick="..." im Markup wird damit nicht mehr ausgefuehrt. Stattdessen:
//   data-lk-call="name"                  ruft window.name(element)
//   data-lk-call="name" data-lk-arg="x"  ruft window.name('x')
// Die Funktionen liegen global, in script.js oder in js/seite/*.js.
document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-lk-call]') : null;
    if (!el) return;
    var fn = window[el.getAttribute('data-lk-call')];
    if (typeof fn !== 'function') return;
    fn(el.hasAttribute('data-lk-arg') ? el.getAttribute('data-lk-arg') : el);
});
document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-lk-nosubmit]')) e.preventDefault();
});

// Termin-Fenster (includes/components/termin-fenster.php), Muster wie Schraubklar.
// Jeder Link mit data-termin oeffnet den <dialog> statt cal.com im neuen Tab.
// Zwei Klicks: Der Kalender bekommt seine Adresse erst nach "Kalender laden"
// und bleibt danach fuer diesen Seitenaufruf da. Mit Cmd/Strg/Shift oder
// Mittelklick oeffnet der Link wie gewohnt einen Tab. Ohne showModal (sehr
// alte Browser) bleibt es beim Link. Esc, Fokusfalle und Fokus-Ruecksprung
// liefert <dialog> selbst.
(function terminFenster() {
    var fenster = document.querySelector('[data-termin-fenster]');
    if (!fenster || typeof fenster.showModal !== 'function') return;
    var kalender = fenster.querySelector('iframe[data-src]');
    var zustimmung = fenster.querySelector('[data-termin-zustimmung]');
    var laedt = fenster.querySelector('[data-termin-laedt]');

    fenster.querySelector('[data-termin-laden]').addEventListener('click', function () {
        zustimmung.hidden = true;
        laedt.hidden = false;
        kalender.hidden = false;
        kalender.addEventListener('load', function () { laedt.hidden = true; }, { once: true });
        kalender.setAttribute('src', kalender.getAttribute('data-src'));
        kalender.focus();
    });
    document.addEventListener('click', function (e) {
        var knopf = e.target && e.target.closest ? e.target.closest('[data-termin]') : null;
        if (!knopf || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        document.documentElement.classList.add('ist-termin-offen');
        fenster.showModal();
        if (typeof gtag === 'function') {
            gtag('event', 'calendly_open', { page_path: location.pathname });
        }
    });
    fenster.querySelector('[data-termin-zu]').addEventListener('click', function () { fenster.close(); });
    // Klick auf den abgedunkelten Rand schliesst; der Rand ist das <dialog> selbst
    fenster.addEventListener('click', function (e) {
        if (e.target === fenster) fenster.close();
    });
    fenster.addEventListener('close', function () {
        document.documentElement.classList.remove('ist-termin-offen');
    });
})();

// FAQ auf /lohnabrechnung-agenturen-startups (frueher als Inline-Handler).
function agToggleFAQ(btn) {
    var antwort = btn.nextElementSibling;
    if (!antwort) return;
    var offen = antwort.classList.toggle('open');
    var icon = btn.querySelector('.ag-faq-icon');
    if (icon) icon.textContent = offen ? '−' : '+';
}

// Anfrageformular: Zusatzfelder ab der Schwelle einblenden, Mitarbeiterzahl
// aus einem Rechner uebernehmen (frueher Inline-Skript in angebot-form.php).
document.querySelectorAll('form[data-lk-angebot]').forEach(function (form) {
    var ma = form.querySelector('input[name="ma"]');
    var plus = form.querySelector('.lk-angebot-plus');
    var schwelle = parseInt(form.getAttribute('data-schwelle'), 10) || 50;
    if (ma && plus) {
        var pruefen = function () { plus.hidden = !(parseInt(ma.value, 10) >= schwelle); };
        ma.addEventListener('input', pruefen);
        ma.addEventListener('change', pruefen);
        pruefen();
    }
    var sel = form.getAttribute('data-prefill');
    var src = sel ? document.querySelector(sel) : null;
    if (src && ma) {
        var sync = function () { if (src.value) { ma.value = src.value; ma.dispatchEvent(new Event('input')); } };
        src.addEventListener('input', sync);
        src.addEventListener('change', sync);
        sync();
    }
});

// Zusaetzlich addEventListener fuer den Fall dass onclick=... nicht greift
document.addEventListener('DOMContentLoaded', function () {
    var btn = document.querySelector('.mobile-menu-toggle');
    if (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleMobileMenu();
        });
    }

    // Auto-close bei Klick auf einen ECHTEN Link (nicht auf Dropdown-Trigger)
    document.querySelectorAll('.nav-menu a').forEach(function (link) {
        // Dropdown-Trigger ueberspringen: die sollen das Menue nicht schliessen
        if (link.classList.contains('nav-has-dropdown')) return;
        link.addEventListener('click', function () {
            var menu = document.querySelector('.nav-menu');
            var toggle = document.querySelector('.mobile-menu-toggle');
            if (menu) menu.classList.remove('active');
            if (toggle) {
                toggle.setAttribute('aria-expanded', 'false');
                toggle.classList.remove('is-open');
            }
            document.body.classList.remove('nav-open');
        });
    });

    // Klick ausserhalb des Menues schliesst es
    document.addEventListener('click', function (e) {
        var menu = document.querySelector('.nav-menu');
        if (!menu || !menu.classList.contains('active')) return;
        if (e.target.closest('.nav-menu') || e.target.closest('.mobile-menu-toggle')) return;
        menu.classList.remove('active');
        var toggle = document.querySelector('.mobile-menu-toggle');
        if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.classList.remove('is-open');
        }
        document.body.classList.remove('nav-open');
    });

    // Mobile Nav-Dropdowns als Akkordeon: Tap auf "Lohnabrechnung"/"HR Services"
    // klappt die Untermenues ein/aus statt direkt zu navigieren (nur <=768px,
    // Desktop-Hover-Verhalten bleibt unveraendert). Schliesst offene Geschwister-
    // Dropdowns, gleiche Konvention wie das FAQ-Akkordeon (toggleFAQ).
    document.querySelectorAll('.nav-has-dropdown').forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
            if (window.innerWidth > 768) return; // Desktop: normale Navigation/Hover
            e.preventDefault();
            var item = trigger.closest('.nav-has-dropdown-item');
            if (!item) return;
            var isOpen = item.classList.contains('dropdown-open');

            document.querySelectorAll('.nav-has-dropdown-item.dropdown-open').forEach(function (openItem) {
                if (openItem === item) return;
                openItem.classList.remove('dropdown-open');
                var openTrigger = openItem.querySelector('.nav-has-dropdown');
                if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
            });

            item.classList.toggle('dropdown-open', !isOpen);
            trigger.setAttribute('aria-expanded', String(!isOpen));
        });
    });
});

// Cookie-Einstellungen zurücksetzen (Footer-Link)
var _cookieReset = document.getElementById('footer-cookie-reset');
if (_cookieReset) {
    _cookieReset.addEventListener('click', function (e) {
        e.preventDefault();
        // Beide Keys löschen (alter + neuer) für Rückwärts-Kompatibilität
        try {
            localStorage.removeItem('lk_consent');
        } catch (err) {}
        var banner = document.getElementById('lk-cookie-banner');
        if (banner) {
            // hidden-Attribut entfernen (HTML5 hidden hat höhere Priorität als display:block)
            banner.removeAttribute('hidden');
            banner.style.display = '';
            banner.style.transform = '';
            document.body.classList.add('has-cookie-banner');
            // Scroll-in via brief animation
            banner.style.opacity = '0';
            requestAnimationFrame(function () {
                banner.style.transition = 'opacity 0.25s';
                banner.style.opacity = '1';
            });
        } else {
            location.reload();
        }
    });
}

// Smooth Scrolling with header offset
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (!href || href === '#') return; // E-Mail-Platzhalter überspringen
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
            // Der Kopf klebt unter dem HRklar-Band, also muessen BEIDE Hoehen
            // abgezogen werden. Ohne das Band landet das Ziel exakt um die
            // Bandhoehe zu hoch und verschwindet darunter.
            // getBoundingClientRect statt offsetHeight: letzteres rundet 86,4 auf 86
            // und das Ziel landet um den Rest hinter der Nav-Kante.
            const navEl = document.querySelector('nav');
            const navHeight = navEl ? navEl.getBoundingClientRect().height : 70;
            const bandEl = document.querySelector('.lk-topband');
            const bandHeight = bandEl ? bandEl.getBoundingClientRect().height : 0;
            const top = target.getBoundingClientRect().top + window.scrollY - navHeight - bandHeight;
            window.scrollTo({ top: top, behavior: 'smooth' });

            // Close mobile menu if open
            const menu = document.querySelector('.nav-menu');
            if (menu) {
                menu.classList.remove('active');
            }
        }
    });
});

// Navigation Compact + Parallax (throttled via requestAnimationFrame)
const _nav = document.querySelector('nav');
const _heroBg = document.querySelector('.hero-bg');
const _heroSection = document.querySelector('.hero');
const _prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const _isDesktop = () => window.innerWidth >= 768;

let _scrollTicking = false;
window.addEventListener('scroll', function () {
    if (!_scrollTicking) {
        window.requestAnimationFrame(function () {
            const sy = window.scrollY;

            // Sticky header
            if (_nav) {
                _nav.classList.toggle('scrolled', sy >= 60);
            }

            // Parallax (nur Desktop, nur wenn reduced-motion nicht aktiv)
            if (_heroBg && _heroSection && _isDesktop() && !_prefersReducedMotion) {
                const heroBottom = _heroSection.getBoundingClientRect().bottom;
                if (heroBottom > 0) {
                    _heroBg.style.transform = `translateY(${sy * 0.25}px)`;
                }
            }

            _scrollTicking = false;
        });
        _scrollTicking = true;
    }
});

// E-Mail-Obfuskierung – baut mailto-Links aus data-Attributen zusammen
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a[data-user][data-domain]').forEach(function (link) {
        const email = link.dataset.user + '@' + link.dataset.domain;
        const subject = link.dataset.subject ? '?subject=' + encodeURIComponent(link.dataset.subject) : '';
        link.href = 'mailto:' + email + subject;
        // Wenn Linktext noch ein Platzhalter ist, ersetzen
        if (!link.textContent.trim() || link.textContent.trim() === '…') {
            link.textContent = email;
        }
    });
});

// ─────────────────────────────────────────────
// GA4 Event Tracking
// ─────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
    if (typeof gtag !== 'function') return;

    // 1. Termin-Fenster: calendly_open feuert terminFenster() beim Oeffnen.

    // 2. CTA-Klick tracken (alle Anchor-Links auf #termin / /#termin + sticky CTA)
    document.querySelectorAll('a[href="#termin"], a[href="/#termin"], .sticky-cta').forEach(function (el) {
        el.addEventListener('click', function () {
            gtag('event', 'cta_click', {
                label: (el.textContent || '').trim().substring(0, 50),
                page_path: location.pathname
            });
        });
    });

    // 3. Scroll-Tiefe tracken (25 / 50 / 75 / 100 % – je einmal pro Seite)
    var scrollFired = { 25: false, 50: false, 75: false, 100: false };
    window.addEventListener('scroll', function () {
        var scrolled = Math.round(
            (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
        );
        [25, 50, 75, 100].forEach(function (depth) {
            if (!scrollFired[depth] && scrolled >= depth) {
                scrollFired[depth] = true;
                gtag('event', 'scroll_depth', { depth: depth, page_path: location.pathname });
            }
        });
    }, { passive: true });

    // 4. Telefon-Klick tracken
    document.querySelectorAll('a[href^="tel:"]').forEach(function (el) {
        el.addEventListener('click', function () {
            gtag('event', 'phone_click', { page_path: location.pathname });
        });
    });

    // 5. Outbound-Link-Klicks tracken (alle target="_blank" auf externe Domains)
    document.querySelectorAll('a[target="_blank"]').forEach(function (el) {
        el.addEventListener('click', function () {
            var href = el.getAttribute('href') || '';
            if (!href.startsWith('http')) return;
            gtag('event', 'outbound_click', {
                destination: href,
                page_path: location.pathname
            });
        });
    });

    // 6. Angebotsformular: erfolgreiche Anfrage tracken (nach PRG-Redirect ?angebot=ok).
    // Query-Param danach aus der URL entfernen, damit ein Reload das Event nicht doppelt zaehlt.
    if (new URLSearchParams(location.search).get('angebot') === 'ok') {
        gtag('event', 'angebot_anfrage', { page_path: location.pathname });
        if (history.replaceState) {
            var params = new URLSearchParams(location.search);
            params.delete('angebot');
            var rest = params.toString();
            history.replaceState(null, '', location.pathname + (rest ? '?' + rest : '') + location.hash);
        }
    }
});

// ─────────────────────────────────────────────
// Exit-Intent-CTA vor lk-sources (Service-Seiten) und ba-related (Blog-Artikel)
// Pro Seite nur einmal eingefügt — lk-sources hat Priorität falls beides vorhanden
// ─────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
    function buildCta(label) {
        var cta = document.createElement('div');
        cta.className = 'lk-pre-sources-cta';

        var text = document.createElement('p');
        text.textContent = label;

        var link = document.createElement('a');
        link.href = '#termin';
        link.textContent = 'Kostenloses Gespräch vereinbaren \u2192';

        cta.appendChild(text);
        cta.appendChild(link);
        return cta;
    }

    // (entfernt 2026-05-23) Exit-Intent-CTA vor lk-sources/ba-related deaktiviert.
    // Die finale ba-cta-box am Artikel-Ende deckt den Termin-Button bereits ab.
    void buildCta;
});

// ─────────────────────────────────────────────

// FAQ Accordion – initialen aria-expanded State auf allen Seiten setzen.
// aria-expanded ist nur auf Bedienelementen erlaubt (axe: aria-allowed-attr).
// Viele Seiten nutzen klickbare <div>/<p> als FAQ-Frage; die bekommen hier
// role="button", Tabulator-Fokus und Enter/Leertaste (WCAG 2.1.1).
// Statische Fragen (immer offen) und Texte innerhalb eines Buttons bleiben unberuehrt.
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[class*="faq-item"] button, [class*="faq-q"]').forEach(el => {
        if (el.tagName !== 'BUTTON') {
            if (el.closest('button')) return;
            const klickbar = el.hasAttribute('onclick') || el.hasAttribute('data-lk-call') || getComputedStyle(el).cursor === 'pointer';
            if (!klickbar) {
                el.removeAttribute('aria-expanded');
                return;
            }
            if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
            if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
            el.addEventListener('keydown', e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    el.click();
                }
            });
            // Manche Seiten-Funktionen klappen nur auf und setzen aria-expanded nicht.
            // Nach jedem Klick den sichtbaren Zustand aller Fragen im selben Block uebernehmen.
            el.dataset.faqSync = '1';
            el.addEventListener('click', () => {
                setTimeout(() => {
                    const block = el.parentElement && el.parentElement.parentElement || document;
                    block.querySelectorAll('[data-faq-sync="1"]').forEach(frage => {
                        const item = frage.parentElement;
                        const antwort = frage.nextElementSibling;
                        let offen = /\b(active|open|is-open|offen)\b/.test(item.className);
                        if (!offen && antwort) {
                            const cs = getComputedStyle(antwort);
                            offen = cs.display !== 'none' && cs.maxHeight !== '0px' && antwort.offsetHeight > 0;
                        }
                        frage.setAttribute('aria-expanded', String(offen));
                    });
                }, 60);
            });
        }
        if (!el.hasAttribute('aria-expanded')) {
            el.setAttribute('aria-expanded', 'false');
        }
    });
});

// FAQ Accordion – universell für Homepage (.faq-item) UND Blog (.ba-faq-item)
// Bug-Fix 2026-05-16: script.js wird mit `defer` geladen und überschrieb daher
// die lokalen toggleFAQ-Funktionen in den Blog-Artikeln. Globale Version
// behandelt jetzt beide Strukturen UND toggelt korrekt (schließt geöffnete FAQs).
function toggleFAQ(button) {
    const faqItem = button.closest('.faq-item, .ba-faq-item');
    if (!faqItem) return;
    const isActive = faqItem.classList.contains('active');

    // Geschwister-Items derselben Liste schließen (Accordion-Verhalten)
    const scope = faqItem.parentElement;
    if (scope) {
        scope.querySelectorAll(':scope > .faq-item, :scope > .ba-faq-item').forEach(item => {
            if (item === faqItem) return;
            item.classList.remove('active');
            const btn = item.querySelector('button');
            if (btn) btn.setAttribute('aria-expanded', 'false');
        });
    }

    // Aktuelles Item toggeln – öffnet ODER schließt
    if (isActive) {
        faqItem.classList.remove('active');
        button.setAttribute('aria-expanded', 'false');
    } else {
        faqItem.classList.add('active');
        button.setAttribute('aria-expanded', 'true');
    }
}

// ============================================================
// SCROLL-REVEAL via IntersectionObserver
// ============================================================
(function initReveal() {
    const revealEls = document.querySelectorAll('.reveal');
    if (!revealEls.length) return;

    // IntersectionObserver required (alle modernen Browser). Fallback: alles sichtbar.
    if (!('IntersectionObserver' in window)) {
        revealEls.forEach(el => el.classList.add('visible'));
        return;
    }

    // Erst jetzt Animation aktivieren (CSS sieht body.js-reveal -> opacity:0)
    document.body.classList.add('js-reveal');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0 });

    revealEls.forEach(el => observer.observe(el));

    // Safety-Net: nach 3 Sekunden alles sichtbar machen (falls Observer aus irgendeinem Grund haengt)
    setTimeout(() => {
        revealEls.forEach(el => el.classList.add('visible'));
    }, 3000);
})();

// ============================================================
// COUNTER ANIMATION (Trust-Bar)
// ============================================================
(function initCounters() {
    const counters = document.querySelectorAll('[data-count]');
    if (!counters.length) return;

    function easeOutQuart(t) {
        return 1 - Math.pow(1 - t, 4);
    }

    function animateCounter(el) {
        const target = parseFloat(el.getAttribute('data-count'));
        const suffix = el.getAttribute('data-suffix') || '';
        const decimals = Number.isInteger(target) ? 0 : 1;
        const duration = 800;
        const start = performance.now();

        function step(now) {
            const elapsed = now - start;
            const progress = Math.min(elapsed / duration, 1);
            const value = easeOutQuart(progress) * target;
            el.textContent = value.toFixed(decimals) + suffix;
            if (progress < 1) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCounter(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });

    counters.forEach(el => observer.observe(el));
})();

(function initReadingProgress() {
    var bar = document.getElementById('readingProgress');
    if (!bar) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
        if (!ticking) {
            window.requestAnimationFrame(function () {
                var docHeight = document.documentElement.scrollHeight - window.innerHeight;
                var scrolled = docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0;
                bar.style.width = Math.min(scrolled, 100) + '%';
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });
})();

// ─────────────────────────────────────────────
// Hero floating doc cards – IntersectionObserver (Ansatz B)
// ─────────────────────────────────────────────
(function () {
    var heroVisual = document.querySelector('.hero-visual');
    if (!heroVisual || !('IntersectionObserver' in window)) {
        // Fallback: sofort anzeigen
        if (heroVisual) heroVisual.classList.add('is-animated');
        return;
    }
    var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-animated');
                obs.unobserve(entry.target);
            }
        });
    }, { threshold: 0.15 });
    obs.observe(heroVisual);
}());

// ============================================================
// Easter Egg: "Drei Runden"
// ------------------------------------------------------------
// Drei kleine Spiele hintereinander, jedes mit einer anderen
// Mechanik, jedes aus dem echten Lohnlauf gegriffen:
//
//   1. Zahltag       Timing        den Monat auf dem Zahltag stoppen
//   2. Posteingang   Reaktion      nur das Dringende anfassen
//   3. Zahlendreher  Konzentration zwei Nummern vergleichen
//
// Am Ende ein Spruch darueber, dass uns das tatsaechlich Spaß macht.
//
// Vier Wege hinein, damit es auch gefunden wird:
//   1. Hinweiszeile im Footer (jede Seite)
//   2. Adresse mit #puenktlich (teilbar)
//   3. fuenfmal aufs Logo (Startseite)
//   4. Konami-Code (fuer die, die ihn kennen)
// Der fuenfte Weg, der Zahltag-Stempel im Monatsraster des Startseiten-Hero,
// ist am 2026-10-15 mit dem Raster weggefallen (Hero zeigt jetzt das Team).
//
// Im Normalbetrieb laufen nur die Listener mit; DOM und CSS entstehen erst
// beim Ausloesen. DOM per createElement, nicht per innerHTML: der
// Security-Hook des Projekts blockt statisches innerHTML.
// ============================================================
(function initEasterEgg() {
    var TAG_VON = 1, TAG_BIS = 34, ZAHLTAG = 30;
    var SPEICHER = 'lk_puenktlich_beste';
    var CODE = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown',
                'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
    var RUNDEN = 3;

    var pos = 0;
    var spiel = null;
    var ruhig = false;
    try {
        ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {}

    function pctVonTag(tag) { return (tag - TAG_VON) / (TAG_BIS - TAG_VON) * 100; }

    function besteHolen() {
        try { return parseInt(localStorage.getItem(SPEICHER), 10) || 0; } catch (e) { return 0; }
    }
    function besteMerken(wert) {
        try { localStorage.setItem(SPEICHER, String(wert)); } catch (e) {}
    }

    // ---------- Ausloeser ----------

    document.addEventListener('keydown', function (e) {
        if (spiel) return;
        var ziel = e.target;
        if (ziel && /^(INPUT|TEXTAREA|SELECT)$/.test(ziel.tagName)) return;
        if (ziel && ziel.isContentEditable) return;
        var taste = e.key && e.key.length === 1 ? e.key.toLowerCase() : e.key;
        if (taste === CODE[pos]) {
            pos++;
            if (pos === CODE.length) { pos = 0; oeffnen(); }
        } else {
            pos = (taste === CODE[0]) ? 1 : 0;
        }
    });

    window.addEventListener('hashchange', function () {
        if (window.location.hash === '#puenktlich') oeffnen();
    });

    document.addEventListener('DOMContentLoaded', function () {
        hinweisImFooter();
        logoKlicks();
        if (window.location.hash === '#puenktlich') oeffnen();
    });

    // Hinweiszeile im Footer, auf jeder Seite. Der sichtbarste der vier Wege.
    function hinweisImFooter() {
        var knopf = document.getElementById('lk-egg-hinweis');
        if (!knopf) return;
        knopf.addEventListener('click', function (e) { e.preventDefault(); oeffnen(); });
    }

    // Fuenfmal aufs Logo. Nur auf der Startseite: dort fuehrt der Logo-Klick
    // ohnehin nur zu einem Reload, deshalb duerfen wir ihn abfangen, ohne
    // Navigation kaputtzumachen. Anderswo bleibt das Logo ein Link nach Hause.
    function logoKlicks() {
        var pfad = window.location.pathname;
        if (pfad !== '/' && !/\/index\.php$/.test(pfad)) return;
        var logo = document.querySelector('.logo');
        if (!logo) return;

        var klicks = 0, letzter = 0;
        logo.addEventListener('click', function (e) {
            if (spiel) return;
            var jetzt = Date.now();
            klicks = (jetzt - letzter < 1500) ? klicks + 1 : 1;
            letzter = jetzt;
            e.preventDefault();
            // Der Logo-Klick soll nicht ins Leere gehen: auf der Startseite
            // ist "nach oben" das, was der Link sinngemaess tun wuerde.
            if (window.scrollY > 0) window.scrollTo({ top: 0, behavior: 'smooth' });

            if (klicks >= 3 && klicks < 5) {
                // Kleine Rueckmeldung, damit man merkt, dass etwas reagiert.
                logo.style.transition = 'transform .18s ease';
                logo.style.transform = 'rotate(-4deg)';
                window.setTimeout(function () { logo.style.transform = ''; }, 180);
            }
            if (klicks >= 5) {
                klicks = 0;
                logo.style.transition = '';
                logo.style.transform = '';
                oeffnen();
            }
        });
    }

    // ---------- Darstellung ----------

    function stil() {
        if (document.getElementById('lk-egg-stil')) return;
        var s = document.createElement('style');
        s.id = 'lk-egg-stil';
        s.textContent = [
            '.lk-egg{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;',
            'justify-content:center;padding:1.5rem;background:rgba(15,23,42,.72);',
            'backdrop-filter:blur(3px)}',
            '.lk-egg-card{width:100%;max-width:480px;background:#fff;border-radius:18px;',
            'padding:1.9rem 2.1rem 1.7rem;box-shadow:0 30px 70px rgba(15,23,42,.35)}',
            '.lk-egg-kopf{display:flex;align-items:baseline;justify-content:space-between;',
            'gap:1rem;margin-bottom:.35rem}',
            '.lk-egg-eyebrow{font-size:.72rem;font-weight:700;letter-spacing:.14em;',
            'text-transform:uppercase;color:#6b7280}',
            '.lk-egg-beste{font-size:.72rem;font-weight:700;color:#64748b;white-space:nowrap}',
            '.lk-egg-title{font-size:1.7rem;font-weight:800;letter-spacing:-.01em;',
            'color:#1f2937;margin:0 0 .45rem}',
            '.lk-egg-sub{font-size:.88rem;line-height:1.55;color:#4b5563;margin:0 0 1.25rem}',
            // Fortschritt: drei Runden
            '.lk-egg-jahr{display:flex;gap:6px;margin-bottom:1.5rem}',
            '.lk-egg-jahr span{flex:1;height:5px;border-radius:3px;background:#e2e8f0}',
            '.lk-egg-jahr span.voll{background:#059669}',
            '.lk-egg-jahr span.daneben{background:#fca5a5}',
            '.lk-egg-jahr span.jetzt{background:#2563eb}',
            // Spiel 1: Leiste
            '.lk-egg-track{position:relative;height:14px;border-radius:7px;background:#e2e8f0;',
            'margin-bottom:.55rem;cursor:pointer}',
            '.lk-egg-zone{position:absolute;top:0;bottom:0;border-radius:3px;',
            'background:rgba(16,185,129,.3)}',
            '.lk-egg-ziel{position:absolute;top:-4px;bottom:-4px;width:3px;margin-left:-1.5px;',
            'border-radius:2px;background:#059669}',
            '.lk-egg-zeiger{position:absolute;top:-5px;bottom:-5px;width:4px;margin-left:-2px;',
            'border-radius:2px;background:#2563eb;box-shadow:0 0 0 4px rgba(37,99,235,.14)}',
            '.lk-egg-ticks{position:relative;height:1rem;margin-bottom:.9rem;',
            'font-size:.72rem;font-weight:600;color:#64748b}',
            '.lk-egg-ticks span{position:absolute;top:0;transform:translateX(-50%);white-space:nowrap}',
            '.lk-egg-ticks span:first-child{transform:none}',
            '.lk-egg-ticks .zahltag{color:#059669;font-weight:800}',
            // Spiel 2: Posteingang
            '.lk-egg-post{position:relative;height:132px;border-radius:12px;background:#f8fafc;',
            'border:1px solid #e2e8f0;margin-bottom:.9rem;display:flex;align-items:center;',
            'justify-content:center;padding:1rem;text-align:center}',
            '.lk-egg-beleg{width:100%}',
            '.lk-egg-beleg-typ{font-size:.66rem;font-weight:800;letter-spacing:.12em;',
            'text-transform:uppercase;margin-bottom:.4rem}',
            '.lk-egg-beleg-typ.sofort{color:#b91c1c}',
            '.lk-egg-beleg-typ.zeit{color:#64748b}',
            '.lk-egg-beleg-txt{font-size:1.05rem;font-weight:700;color:#1f2937;line-height:1.35}',
            '.lk-egg-uhr{position:absolute;left:0;bottom:0;height:4px;border-radius:0 0 0 12px;',
            'background:#2563eb;width:100%}',
            // Spiel 3: Zahlendreher
            '.lk-egg-nr{display:flex;flex-direction:column;gap:.5rem;align-items:center;',
            'padding:1.15rem;border-radius:12px;background:#f8fafc;border:1px solid #e2e8f0;',
            'margin-bottom:.9rem}',
            '.lk-egg-nr code{font-family:ui-monospace,SFMono-Regular,Menlo,monospace;',
            'font-size:1.5rem;font-weight:700;letter-spacing:.16em;color:#1f2937}',
            '.lk-egg-nr-label{font-size:.66rem;font-weight:800;letter-spacing:.12em;',
            'text-transform:uppercase;color:#6b7280}',
            // gemeinsam
            '.lk-egg-status{min-height:3.4rem;font-size:.95rem;line-height:1.5;color:#1f2937;',
            'font-weight:700;margin-bottom:1.1rem}',
            '.lk-egg-status.daneben{color:#b91c1c}',
            '.lk-egg-status em{display:block;font-style:normal;font-weight:400;font-size:.85rem;',
            'color:#6b7280;margin-top:.3rem}',
            '.lk-egg-status a{color:#1d4ed8}',
            '.lk-egg-btns{display:flex;gap:.6rem;flex-wrap:wrap}',
            '.lk-egg-btn{font:inherit;font-size:.9rem;font-weight:700;padding:.7rem 1.4rem;',
            'border-radius:50px;border:2px solid transparent;cursor:pointer}',
            '.lk-egg-btn--p{background:#2563eb;color:#fff}',
            '.lk-egg-btn--p:hover{background:#1e40af}',
            '.lk-egg-btn--s{background:#fff;color:#2563eb;border-color:#2563eb}',
            '.lk-egg-btn--s:hover{background:#eff6ff}',
            '.lk-egg-btn:focus-visible{outline:3px solid #93c5fd;outline-offset:2px}',
            '@media (max-width:480px){.lk-egg-card{padding:1.6rem 1.4rem 1.4rem}',
            '.lk-egg-title{font-size:1.45rem}.lk-egg-btn{flex:1 1 auto;text-align:center}}'
        ].join('');
        document.head.appendChild(s);
    }

    function el(tag, klasse, text) {
        var n = document.createElement(tag);
        if (klasse) n.className = klasse;
        if (text) n.textContent = text;
        return n;
    }

    function link(href, text) {
        var a = document.createElement('a');
        a.href = href;
        a.textContent = text;
        return a;
    }

    function mische(liste) {
        var a = liste.slice();
        for (var i = a.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var t = a[i]; a[i] = a[j]; a[j] = t;
        }
        return a;
    }

    // ---------- Rahmen ----------

    function oeffnen() {
        if (spiel) return;
        stil();
        var vorherFokus = document.activeElement;

        var runde = 0;            // 0..2
        var treffer = 0;
        var ergebnisse = [];      // true/false je Runde
        var beste = besteHolen();
        var aufraeumen = null;    // Aufraeumfunktion der laufenden Runde

        var karte = el('div', 'lk-egg-card');
        karte.setAttribute('role', 'dialog');
        karte.setAttribute('aria-modal', 'true');
        karte.setAttribute('aria-labelledby', 'lk-egg-h');

        var kopf = el('div', 'lk-egg-kopf');
        var eyebrow = el('div', 'lk-egg-eyebrow', 'Runde 1 von 3');
        var besteAnzeige = el('div', 'lk-egg-beste');
        kopf.appendChild(eyebrow); kopf.appendChild(besteAnzeige);
        karte.appendChild(kopf);

        var h = el('h2', 'lk-egg-title', '');
        h.id = 'lk-egg-h';
        karte.appendChild(h);
        var sub = el('p', 'lk-egg-sub', '');
        karte.appendChild(sub);

        var fortschritt = el('div', 'lk-egg-jahr');
        fortschritt.setAttribute('aria-hidden', 'true');
        var felder = [];
        for (var i = 0; i < RUNDEN; i++) { var f = el('span'); felder.push(f); fortschritt.appendChild(f); }
        karte.appendChild(fortschritt);

        // Buehne: hier rendert jede Runde ihr eigenes Spielfeld hinein.
        var buehne = el('div', 'lk-egg-buehne');
        karte.appendChild(buehne);

        var status = el('div', 'lk-egg-status');
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        karte.appendChild(status);

        var btns = el('div', 'lk-egg-btns');
        var btnP = el('button', 'lk-egg-btn lk-egg-btn--p', 'Los');
        btnP.type = 'button';
        var btnS = el('button', 'lk-egg-btn lk-egg-btn--s', 'Schließen');
        btnS.type = 'button';
        btns.appendChild(btnP); btns.appendChild(btnS);
        karte.appendChild(btns);

        var huelle = el('div', 'lk-egg');
        huelle.appendChild(karte);
        document.body.appendChild(huelle);
        spiel = huelle;

        huelle.addEventListener('mousedown', function (e) { if (e.target === huelle) schliessen(); });
        document.addEventListener('keydown', tastatur, true);
        btnS.addEventListener('click', schliessen);

        function tastatur(e) {
            if (e.key === 'Escape') { e.preventDefault(); schliessen(); return; }
            // aria-modal verspricht, dass der Fokus drinbleibt. Also einhalten.
            if (e.key === 'Tab') {
                var f = karte.querySelectorAll('button:not([disabled]), a[href]');
                if (!f.length) return;
                var erster = f[0], letzter = f[f.length - 1];
                if (e.shiftKey && document.activeElement === erster) {
                    e.preventDefault(); letzter.focus();
                } else if (!e.shiftKey && document.activeElement === letzter) {
                    e.preventDefault(); erster.focus();
                }
                return;
            }
            if (aktuelleTaste) aktuelleTaste(e);
        }
        var aktuelleTaste = null;

        function schliessen() {
            if (!spiel) return;
            if (aufraeumen) { aufraeumen(); aufraeumen = null; }
            document.removeEventListener('keydown', tastatur, true);
            if (huelle.parentNode) huelle.parentNode.removeChild(huelle);
            spiel = null;
            if (vorherFokus && vorherFokus.focus) vorherFokus.focus();
        }

        function besteZeigen() {
            besteAnzeige.textContent = beste ? 'Bestwert: ' + beste + ' von 3' : '';
        }

        function fortschrittZeigen() {
            for (var k = 0; k < RUNDEN; k++) {
                felder[k].className = '';
                if (k < ergebnisse.length) felder[k].className = ergebnisse[k] ? 'voll' : 'daneben';
                else if (k === runde) felder[k].className = 'jetzt';
            }
        }

        function melde(text, klein, daneben) {
            status.className = 'lk-egg-status' + (daneben ? ' daneben' : '');
            status.textContent = '';
            status.appendChild(document.createTextNode(text));
            if (klein) {
                var e2 = el('em');
                if (typeof klein === 'string') e2.textContent = klein;
                else e2.appendChild(klein);
                status.appendChild(e2);
            }
        }

        // Eine Runde ist vorbei. Ergebnis merken, weiter oder Abschluss.
        function rundeFertig(ok, text, klein) {
            ergebnisse.push(ok);
            if (ok) treffer++;
            fortschrittZeigen();
            melde(text, klein, !ok);
            aktuelleTaste = null;
            if (aufraeumen) { aufraeumen(); aufraeumen = null; }

            if (runde < RUNDEN - 1) {
                btnP.textContent = 'Nächste Runde';
                btnP.onclick = function () { runde++; rundeStarten(); };
            } else {
                btnP.textContent = 'Und jetzt?';
                btnP.onclick = abschluss;
            }
            btnP.focus();
        }

        function rundeStarten() {
            buehne.textContent = '';
            eyebrow.textContent = 'Runde ' + (runde + 1) + ' von 3';
            fortschrittZeigen();
            besteZeigen();
            if (runde === 0)      aufraeumen = spielZahltag(buehne, h, sub, melde, btnP, setTaste, rundeFertig);
            else if (runde === 1) aufraeumen = spielPosteingang(buehne, h, sub, melde, btnP, setTaste, rundeFertig);
            else                  aufraeumen = spielZahlendreher(buehne, h, sub, melde, btnP, setTaste, rundeFertig);
        }

        function setTaste(fn) { aktuelleTaste = fn; }

        function abschluss() {
            buehne.textContent = '';
            aktuelleTaste = null;
            eyebrow.textContent = 'Feierabend';
            fortschrittZeigen();
            if (treffer > beste) { beste = treffer; besteMerken(treffer); }
            besteZeigen();

            var titel, spruch;
            if (treffer === 3) {
                titel  = 'Drei von drei.';
                spruch = 'Timing, Reaktion, Konzentration. Viel mehr ist Lohnabrechnung nicht. ' +
                         'Nur eben jeden Monat, mit echten Menschen am anderen Ende und Fristen, ' +
                         'die sich nicht darum scheren, ob gerade Grippewelle ist.';
            } else if (treffer === 2) {
                titel  = 'Zwei von drei.';
                spruch = 'Zwei von drei ist im echten Lohnlauf leider eine Korrekturabrechnung. ' +
                         'Kein Drama, machen wir auch. Nur seltener, als du denkst.';
            } else if (treffer === 1) {
                titel  = 'Einer sitzt.';
                spruch = 'Einer von drei. Genau deshalb macht das jemand hauptberuflich, ' +
                         'und nicht die Geschäftsführung sonntagabends.';
            } else {
                titel  = 'Keiner. Ehrlich jetzt?';
                spruch = 'Null von drei. Willkommen im Club, so fühlt sich der erste Monat ' +
                         'ohne Lohnbüro auch an.';
            }

            h.textContent = titel;
            sub.textContent = spruch;

            var pointe = el('span');
            pointe.appendChild(document.createTextNode(
                'Und falls du dich fragst, warum jemand daraus ein Spiel baut: ' +
                'weil uns das hier tatsächlich Spaß macht. Seit Jahren. ' +
                'Wir wissen selbst, wie das klingt. '));
            pointe.appendChild(link('/karriere', 'Wir stellen übrigens ein.'));
            melde('Danke fürs Mitspielen.', pointe);

            btnP.textContent = 'Nochmal';
            btnP.onclick = function () {
                runde = 0; treffer = 0; ergebnisse = [];
                rundeStarten();
            };
            btnP.focus();
        }

        // Start. Fokus in den Dialog holen, sonst haengt ein Tastaturnutzer
        // hinter dem Overlay fest.
        besteZeigen();
        rundeStarten();
        btnP.focus();
    }

    // ---------- Runde 1: Zahltag (Timing) ----------

    function spielZahltag(buehne, h, sub, melde, btnP, setTaste, fertig) {
        h.textContent = 'Pünktlich zum Zahltag.';
        sub.textContent = 'Der Monat läuft einmal durch. Stopp ihn auf dem 30., dem Zahltag. ' +
                          'Leertaste oder Klick auf die Leiste.';

        var track = el('div', 'lk-egg-track');
        var zone = el('span', 'lk-egg-zone');
        var zielLinie = el('span', 'lk-egg-ziel');
        var zeiger = el('span', 'lk-egg-zeiger');
        zeiger.style.left = '0%';
        var toleranz = 2.4;
        zone.style.left = pctVonTag(ZAHLTAG - toleranz) + '%';
        zone.style.width = (pctVonTag(ZAHLTAG + toleranz) - pctVonTag(ZAHLTAG - toleranz)) + '%';
        zielLinie.style.left = pctVonTag(ZAHLTAG) + '%';
        track.appendChild(zone); track.appendChild(zielLinie); track.appendChild(zeiger);
        buehne.appendChild(track);

        var ticks = el('div', 'lk-egg-ticks');
        var t1 = el('span', null, '1.'); t1.style.left = '0%';
        var t15 = el('span', null, '15.'); t15.style.left = pctVonTag(15) + '%';
        var tZ = el('span', 'zahltag', '30.'); tZ.style.left = pctVonTag(ZAHLTAG) + '%';
        ticks.appendChild(t1); ticks.appendChild(t15); ticks.appendChild(tZ);
        buehne.appendChild(ticks);

        var x = 0, raf = null, letzterTs = 0, laeuft = false;
        var tempo = 34;   // Prozent pro Sekunde

        melde('Bereit.', 'Der Monat läuft nur einmal. Kein zweiter Vorbeilauf.');
        btnP.textContent = 'Start';
        btnP.onclick = starten;

        function starten() {
            laeuft = true;
            x = 0; letzterTs = 0;
            zeiger.style.left = '0%';
            melde('Läuft.', 'Leertaste oder Klick.');
            btnP.textContent = 'Stopp';
            btnP.onclick = stoppen;
            raf = window.requestAnimationFrame(schritt);
        }

        function schritt(ts) {
            if (!laeuft) return;
            if (!letzterTs) letzterTs = ts;
            var dt = (ts - letzterTs) / 1000;
            letzterTs = ts;
            x += tempo * dt;
            if (x >= 100) {
                x = 100;
                zeiger.style.left = '100%';
                laeuft = false;
                fertig(false, 'Durchgelaufen.',
                       'Der Monat ist vorbei, der Lohn nicht raus. Passiert genau einmal, dann nie wieder.');
                return;
            }
            zeiger.style.left = x + '%';
            raf = window.requestAnimationFrame(schritt);
        }

        function stoppen() {
            if (!laeuft) return;
            laeuft = false;
            if (raf) window.cancelAnimationFrame(raf);
            var tag = TAG_VON + (x / 100) * (TAG_BIS - TAG_VON);
            var ab = Math.abs(tag - ZAHLTAG);
            if (ab <= toleranz) {
                fertig(true, 'Am 30. Sitzt.', 'Abweichung: ' + ab.toFixed(1) + ' Tage.');
            } else if (tag < ZAHLTAG) {
                fertig(false, 'Zu früh, am ' + Math.round(tag) + '.',
                       'Zu früh heisst: die Stunden vom Monatsende fehlen noch.');
            } else {
                fertig(false, 'Zu spät, am ' + Math.round(tag) + '.',
                       'Zu spät heisst: das Geld ist nicht am Ersten auf dem Konto.');
            }
        }

        track.addEventListener('click', stoppen);
        setTaste(function (e) {
            if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                if (laeuft) stoppen(); else if (btnP.textContent === 'Start') starten();
            }
        });

        return function () { laeuft = false; if (raf) window.cancelAnimationFrame(raf); };
    }

    // ---------- Runde 2: Posteingang (Reaktion) ----------

    function spielPosteingang(buehne, h, sub, melde, btnP, setTaste, fertig) {
        h.textContent = 'Posteingang.';
        sub.textContent = 'Fünf Vorgänge, jeder zwei Sekunden. Steht SOFORT dabei, drück die ' +
                          'Leertaste. Steht HAT ZEIT dabei, lass die Finger still.';

        var BELEGE = mische([
            { txt: 'Neueintritt morgen früh',        sofort: true  },
            { txt: 'Krankmeldung, dritter Tag',      sofort: true  },
            { txt: 'Adressänderung Frau Weber',      sofort: false },
            { txt: 'Urlaubsantrag für November',     sofort: false },
            { txt: 'Minijob endet zum Monatsende',   sofort: true  },
            { txt: 'Neue Bankverbindung ab nächstem Monat', sofort: false },
            { txt: 'Elternzeit beginnt kommende Woche',     sofort: true  },
            { txt: 'Frage zur Gehaltsabrechnung Mai',       sofort: false }
        ]).slice(0, 5);

        var idx = 0, richtig = 0, gedrueckt = false, timer = null, rafU = null, start = 0;
        var DAUER = 2000;

        var feld = el('div', 'lk-egg-post');
        var uhr = el('span', 'lk-egg-uhr');
        buehne.appendChild(feld);
        feld.appendChild(uhr);

        melde('Bereit.', 'Fünf Vorgänge. Nur das Dringende anfassen.');
        btnP.textContent = 'Start';
        btnP.onclick = starten;

        function starten() {
            btnP.textContent = 'Warte';
            btnP.onclick = null;
            btnP.disabled = true;
            zeigen();
        }

        function zeigen() {
            if (idx >= BELEGE.length) return auswerten();
            gedrueckt = false;
            var b = BELEGE[idx];

            feld.textContent = '';
            feld.appendChild(uhr);
            var wrap = el('div', 'lk-egg-beleg');
            wrap.appendChild(el('div', 'lk-egg-beleg-typ ' + (b.sofort ? 'sofort' : 'zeit'),
                                 b.sofort ? 'Sofort' : 'Hat Zeit'));
            wrap.appendChild(el('div', 'lk-egg-beleg-txt', b.txt));
            feld.appendChild(wrap);

            melde('Vorgang ' + (idx + 1) + ' von ' + BELEGE.length + '.',
                  b.sofort ? 'Leertaste.' : 'Nichts tun.');

            start = (window.performance && performance.now) ? performance.now() : Date.now();
            uhr.style.width = '100%';
            if (!ruhig) rafU = window.requestAnimationFrame(uhrLaufen);
            timer = window.setTimeout(function () { bewerten(false); }, DAUER);
        }

        function uhrLaufen(ts) {
            var jetzt = ts || ((window.performance && performance.now) ? performance.now() : Date.now());
            var rest = Math.max(0, 1 - (jetzt - start) / DAUER);
            uhr.style.width = (rest * 100) + '%';
            if (rest > 0) rafU = window.requestAnimationFrame(uhrLaufen);
        }

        function bewerten(hatGedrueckt) {
            if (timer) { window.clearTimeout(timer); timer = null; }
            if (rafU) { window.cancelAnimationFrame(rafU); rafU = null; }
            var b = BELEGE[idx];
            if (b.sofort === hatGedrueckt) richtig++;
            idx++;
            window.setTimeout(zeigen, 260);
        }

        function auswerten() {
            btnP.disabled = false;
            feld.textContent = '';
            feld.appendChild(uhr);
            uhr.style.width = '0%';
            var wrap = el('div', 'lk-egg-beleg');
            wrap.appendChild(el('div', 'lk-egg-beleg-txt', richtig + ' von ' + BELEGE.length + ' richtig'));
            feld.appendChild(wrap);

            if (richtig === BELEGE.length) {
                fertig(true, 'Posteingang leer.', 'Alle fünf richtig einsortiert.');
            } else {
                fertig(false, richtig + ' von ' + BELEGE.length + '.',
                       'Reicht nicht ganz. Im echten Posteingang liegen davon dreißig am Tag.');
            }
        }

        setTaste(function (e) {
            if (e.key !== ' ' && e.key !== 'Enter') return;
            e.preventDefault();
            if (btnP.disabled === false && btnP.textContent === 'Start') { starten(); return; }
            if (gedrueckt || idx >= BELEGE.length || !timer) return;
            gedrueckt = true;
            bewerten(true);
        });
        feld.addEventListener('click', function () {
            if (gedrueckt || idx >= BELEGE.length || !timer) return;
            gedrueckt = true;
            bewerten(true);
        });

        return function () {
            if (timer) window.clearTimeout(timer);
            if (rafU) window.cancelAnimationFrame(rafU);
            btnP.disabled = false;
        };
    }

    // ---------- Runde 3: Zahlendreher (Konzentration) ----------

    function spielZahlendreher(buehne, h, sub, melde, btnP, setTaste, fertig) {
        h.textContent = 'Zahlendreher.';
        sub.textContent = 'Vier Paare. Sind die beiden Nummern gleich? Pfeil links für gleich, ' +
                          'Pfeil rechts für verdreht. Oder die zwei Knöpfe.';

        var PAARE = 4;
        var idx = 0, richtig = 0;

        var box = el('div', 'lk-egg-nr');
        var lab1 = el('div', 'lk-egg-nr-label', 'Meldung');
        var nr1 = el('code');
        var lab2 = el('div', 'lk-egg-nr-label', 'Personalakte');
        var nr2 = el('code');
        box.appendChild(lab1); box.appendChild(nr1);
        box.appendChild(lab2); box.appendChild(nr2);
        buehne.appendChild(box);

        var wahl = el('div', 'lk-egg-btns');
        wahl.style.marginBottom = '.9rem';
        var bGleich = el('button', 'lk-egg-btn lk-egg-btn--s', 'Gleich');
        bGleich.type = 'button';
        var bAnders = el('button', 'lk-egg-btn lk-egg-btn--s', 'Verdreht');
        bAnders.type = 'button';
        wahl.appendChild(bGleich); wahl.appendChild(bAnders);
        buehne.appendChild(wahl);

        bGleich.addEventListener('click', function () { antwort(true); });
        bAnders.addEventListener('click', function () { antwort(false); });

        var aktuellGleich = false;

        melde('Bereit.', 'Vier Paare. Ein Zahlendreher ist der häufigste Fehler überhaupt.');
        btnP.textContent = 'Start';
        btnP.onclick = starten;

        function nummer() {
            var s = '';
            for (var i = 0; i < 8; i++) s += Math.floor(Math.random() * 10);
            return s;
        }

        function dreher(s) {
            // Genau zwei benachbarte, unterschiedliche Ziffern tauschen.
            for (var versuch = 0; versuch < 40; versuch++) {
                var i = Math.floor(Math.random() * (s.length - 1));
                if (s[i] !== s[i + 1]) {
                    return s.slice(0, i) + s[i + 1] + s[i] + s.slice(i + 2);
                }
            }
            return s.slice(0, s.length - 1) + ((parseInt(s[s.length - 1], 10) + 1) % 10);
        }

        function starten() {
            btnP.textContent = 'Läuft';
            btnP.onclick = null;
            btnP.disabled = true;
            naechstes();
        }

        function naechstes() {
            if (idx >= PAARE) return auswerten();
            var a = nummer();
            aktuellGleich = Math.random() < 0.5;
            nr1.textContent = a;
            nr2.textContent = aktuellGleich ? a : dreher(a);
            melde('Paar ' + (idx + 1) + ' von ' + PAARE + '.', 'Gleich oder verdreht?');
        }

        function antwort(gleich) {
            if (btnP.disabled === false || idx >= PAARE) return;
            if (gleich === aktuellGleich) richtig++;
            idx++;
            naechstes();
        }

        function auswerten() {
            btnP.disabled = false;
            bGleich.disabled = true;
            bAnders.disabled = true;
            if (richtig === PAARE) {
                fertig(true, 'Alle vier erkannt.', 'Genau dieses Auge brauchst du bei Meldungen.');
            } else {
                fertig(false, richtig + ' von ' + PAARE + '.',
                       'Ein Zahlendreher in der Versicherungsnummer, und die Meldung kommt zurück.');
            }
        }

        setTaste(function (e) {
            if (e.key === ' ' || e.key === 'Enter') {
                if (btnP.disabled === false && btnP.textContent === 'Start') { e.preventDefault(); starten(); }
                return;
            }
            if (btnP.disabled !== true) return;
            if (e.key === 'ArrowLeft')  { e.preventDefault(); antwort(true); }
            if (e.key === 'ArrowRight') { e.preventDefault(); antwort(false); }
        });

        return function () {};
    }
})();


// ============================================================
// Scrollbare Tabellen per Tastatur erreichbar machen (WCAG 2.1.1,
// axe: scrollable-region-focusable). Betrifft vor allem Mobil, wo
// breite Tabellen in einem horizontal scrollbaren Rahmen liegen.
// ============================================================
(function initScrollRegionen() {
    function markiere() {
        document.querySelectorAll('main div, main figure, main section, main table').forEach(function (el) {
            var ox = getComputedStyle(el).overflowX;
            var scrollt = (ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth;
            if (!scrollt) {
                if (el.dataset.scrollRegion === '1') {
                    el.removeAttribute('tabindex');
                    el.removeAttribute('role');
                    el.removeAttribute('aria-label');
                    delete el.dataset.scrollRegion;
                }
                return;
            }
            if (el.hasAttribute('tabindex') || el.querySelector('a, button, input, select, textarea, [tabindex]')) return;
            var tabelle = el.querySelector('caption, th');
            el.setAttribute('tabindex', '0');
            el.setAttribute('role', 'region');
            el.setAttribute('aria-label', tabelle ? 'Tabelle, seitlich scrollbar' : 'Seitlich scrollbarer Bereich');
            el.dataset.scrollRegion = '1';
        });
    }
    var warte;
    document.addEventListener('DOMContentLoaded', markiere);
    window.addEventListener('load', markiere);
    window.addEventListener('resize', function () {
        clearTimeout(warte);
        warte = setTimeout(markiere, 250);
    });
})();

// ============================================================
// STARTSEITE MOBIL: Termin-Leiste erst nach dem Hero (2026-10-17)
// Die Leiste ist per CSS nur bis 768 px aktiv. Sie erscheint, sobald
// weder Hero noch Termin-Abschnitt noch Footer im Bild sind, und
// verschwindet dort, wo es ohnehin einen Termin-Knopf gibt.
// ============================================================
(function () {
    function start() {
        if (!document.body.classList.contains('is-homepage')) return;
        var cta = document.querySelector('.sticky-cta');
        if (!cta || !('IntersectionObserver' in window)) return;
        var ziele = ['.hero', '#termin', 'footer'].map(function (sel) {
            return document.querySelector(sel);
        }).filter(Boolean);
        var imBild = [];
        var io = new IntersectionObserver(function (eintraege) {
            eintraege.forEach(function (e) {
                var ohne = imBild.filter(function (z) { return z !== e.target; });
                imBild = e.isIntersecting ? ohne.concat([e.target]) : ohne;
            });
            cta.classList.toggle('ist-sichtbar', imBild.length === 0);
        });
        ziele.forEach(function (z) { io.observe(z); });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();

// ============================================================
// STARTSEITE: Preisrechner im Preisabschnitt (2026-10-17)
// Rechnet ab 12,50 € gegen die uebliche Steuerberater-Spanne von
// 18 bis 30 € (§ 34 Abs. 2 StBVV). Bei Preisaenderung hier und in
// index.php pflegen. Der Knopf traegt die Zahl ins Angebotsformular.
// ============================================================
(function () {
    var PREIS_LK = 12.5;
    var STB_VON = 18;
    var STB_BIS = 30;

    function euro(x) {
        return x.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    function personen(n) {
        return n === 1 ? '1 Person' : n + ' Mitarbeitende';
    }

    function start() {
        var box = document.querySelector('[data-lk-rechner]');
        if (!box) return;
        var regler = box.querySelector('input[type="range"]');
        var anzahl = box.querySelector('[data-lk-rechner-anzahl]');
        var lk = box.querySelector('[data-lk-rechner-lk]');
        var stb = box.querySelector('[data-lk-rechner-stb]');
        var ansage = box.querySelector('[data-lk-rechner-ansage]');
        var cta = document.querySelector('[data-lk-rechner-cta]');
        var ctaText = document.querySelector('[data-lk-rechner-cta-text]');
        if (!regler || !anzahl || !lk || !stb) return;
        var warte;

        function aktualisieren() {
            var n = parseInt(regler.value, 10) || 1;
            anzahl.textContent = String(n);
            lk.textContent = 'ab ' + euro(n * PREIS_LK);
            stb.textContent = euro(n * STB_VON) + ' bis ' + euro(n * STB_BIS);
            if (ctaText) ctaText.textContent = personen(n);
            // Vorlesesoftware bekommt die Summe erst, wenn der Regler ruht
            clearTimeout(warte);
            warte = setTimeout(function () {
                if (ansage) ansage.textContent = personen(n) + ': Lohnklar ab ' + euro(n * PREIS_LK) +
                    ' im Monat, Steuerberater üblich ' + euro(n * STB_VON) + ' bis ' + euro(n * STB_BIS) + '.';
            }, 600);
        }

        regler.addEventListener('input', aktualisieren);
        regler.addEventListener('change', aktualisieren);

        if (cta) {
            cta.addEventListener('click', function () {
                var feld = document.querySelector('#angebot input[name="ma"]');
                if (!feld) return;
                feld.value = regler.value;
                feld.dispatchEvent(new Event('input', { bubbles: true }));
            });
        }
        aktualisieren();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();
